import buildApi from './buildApi';
import m3castLightAxios from './m3castLightAPI.axios';
import m3castHdmiAxios from './m3castHdmiAPI.axios';
import streamcastAxios from './streamcastAPI.axios';

export const STATUS = {
  INITIAL: 'initial',
  LOADING: 'loading',
  READY: 'ready',
  MISSING_INFORMATION: 'error_information',
  WRONG_CODE: 'error_code',
};
export const DEVICE_STATUS = {
  FREE: 'free',
  USED: 'in_use',
  RESERVED: 'reserved',
};
export const DEVICE_TYPES = {
  CHROMECAST: 'chromecast',
  APPLETV: 'apple_tv',
};

export const DEVICE_VARIANTS = {
  CENTRAL: 'central',
  HDMI: 'hdmi',
  BUILTIN: 'builtin',
};

export const streamcastAPI = buildApi(streamcastAxios);
export const m3castLightAPI = buildApi(m3castLightAxios);
export const m3castHdmiAPI = buildApi(m3castHdmiAxios);
